// extracted by mini-css-extract-plugin
module.exports = {"singleTransaction":"_9149bee","currency":"_7c9e42b","instrumentNumber":"_66bf650","toggle":"_0c824fa","totalSummary":"_4eda972","amount":"_d4af736","avatar":"_77743e9"};